import ko from "knockout";

export default class Holiday {
    name: string;
    bonus50: KnockoutObservable<boolean>;
    timeForTime: KnockoutObservable<boolean>;

    constructor(name: string) {
        this.name = name;
        this.bonus50 = ko.observable(false);
        this.timeForTime = ko.observable(false);

        this.bonus50.subscribe((newValue) => {
            if(newValue) {
                this.timeForTime(false);
            }
        })

        this.timeForTime.subscribe((newValue) => {
            if(newValue) {
                this.bonus50(false);
            }
        })
    }

    toJson() {
        return {
            name: this.name,
            bonus_50: this.bonus50(),
            time_for_time: this.timeForTime()
        };
    }
}
